module.exports = __webpack_public_path__ + "img/pro_eight_5.31bdf454.jpg";